import { ListingStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export const labelByListingStatus: Record<string, string> = {
  [ListingStatus.earlyListed]: 'Early Listed',
  [ListingStatus.preListed]: 'Pre-Listed',
  [ListingStatus.listed]: 'Listed',
  [ListingStatus.unlisted]: 'Unlisted',
}
